import { getEnvironment, getParameterByName } from "../../utils";
import { matchesTCode } from "./utils";

const log = console;

export default {
  enable() {},
  init() {},
  async enviar() {
    matchesTCode("afl--aip", async function () {
      const environment = getEnvironment();
      const urlpostback =
        environment.name === "prod"
          ? "https://api.ar.alprestamo.io"
          : "https://sandbox.api.ar.alprestamo.io";
      const tracking_id = getParameterByName("tracking_id");

      if (tracking_id) {
        try {
          const response = await fetch(
            `${urlpostback}/bid/postback/only-by-url?tracking_id=${tracking_id}&status=granted`
          );
          await response.json();
        } catch (error) {
          log.error(`AlPrestamo error`, error);
        }
      }
    });
  }
};
